/**
 * FTW — página de produto (handoff de 23/10/2026).
 * - Nome do produto em no máximo 2 linhas: reduz 1px por vez até caber (mínimo 18px no celular,
 *   22px no computador). Mede por offsetHeight / (1.08 × fonte), não por scrollHeight: os glifos da
 *   Oswald passam da caixa de linha de 1.08 e o scrollHeight erra a conta.
 * - Descrição recolhida: botão "Ler descrição completa" abre e fecha; texto curto não ganha botão.
 */
(function () {
  var ALTURA_LINHA = 1.08;

  function ajustaTitulo(h1) {
    var celular = window.matchMedia('(max-width: 749px)').matches;
    var minimo = celular ? 18 : 22;
    h1.style.fontSize = '';
    var tamanho = parseFloat(getComputedStyle(h1).fontSize);
    var linhas = function () {
      return Math.round(h1.offsetHeight / (ALTURA_LINHA * tamanho));
    };
    while (linhas() > 2 && tamanho > minimo) {
      tamanho -= 1;
      h1.style.fontSize = tamanho + 'px';
    }
  }

  function titulos() {
    document.querySelectorAll('[data-ftw-titulo]').forEach(ajustaTitulo);
  }

  function descricao(caixa) {
    var texto = caixa.querySelector('[data-ftw-descricao-texto]');
    var botao = caixa.querySelector('[data-ftw-descricao-botao]');
    var rotulo = caixa.querySelector('[data-ftw-descricao-rotulo]');
    var seta = botao.querySelector('.ftw-descricao__seta');
    var recolhida = parseFloat(getComputedStyle(texto).maxHeight) || 240;

    if (texto.scrollHeight <= recolhida + 24) {
      caixa.classList.add('is-curta');
      return;
    }
    botao.hidden = false;

    botao.addEventListener('click', function () {
      var abrir = !caixa.classList.contains('is-aberta');
      if (abrir) {
        texto.style.maxHeight = recolhida + 'px';
        caixa.classList.add('is-aberta');
        void texto.offsetHeight;
        requestAnimationFrame(function () {
          texto.style.maxHeight = texto.scrollHeight + 'px';
        });
        texto.addEventListener('transitionend', function fim() {
          texto.removeEventListener('transitionend', fim);
          if (caixa.classList.contains('is-aberta')) texto.style.maxHeight = 'none';
        });
      } else {
        texto.style.maxHeight = texto.scrollHeight + 'px';
        void texto.offsetHeight; // fixa a altura de partida da animação
        requestAnimationFrame(function () {
          caixa.classList.remove('is-aberta');
          texto.style.maxHeight = '';
        });
        var topo = caixa.getBoundingClientRect().top;
        if (topo < 0) caixa.scrollIntoView({ block: 'start' });
      }
      botao.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      rotulo.textContent = abrir ? 'Mostrar menos' : 'Ler descrição completa';
      seta.textContent = abrir ? '▲' : '▼';
    });
  }

  // Altura real da barra fixa de compra (muda com o tamanho da tela): os botões flutuantes
  // ("Copiar meu link", WhatsApp) ficam logo acima dela, via --ftw-barra-h em ftw-produto.css.
  function alturaBarra() {
    var barra = document.querySelector('cart-bar');
    if (!barra) return;
    var mede = function () {
      document.documentElement.style.setProperty('--ftw-barra-h', barra.offsetHeight + 'px');
    };
    mede();
    if ('ResizeObserver' in window) new ResizeObserver(mede).observe(barra);
  }

  // Avaliações (Judge.me): a lista começa recolhida, como a descrição. O widget monta sozinho e
  // mais tarde, por isso espera a primeira avaliação aparecer antes de medir.
  function avaliacoes() {
    var secao = document.getElementById('avaliacoes');
    if (!secao) return;

    var pronto = function () {
      var corpo = secao.querySelector('.jm-review-widget__body');
      if (!corpo || !secao.querySelector('.jm-review-item')) return false;

      var limite = window.matchMedia('(min-width: 750px)').matches ? 440 : 520;
      if (corpo.scrollHeight <= limite + 120) return true; // poucas avaliações: mostra tudo

      secao.classList.add('is-recolhida');
      var botao = document.createElement('button');
      botao.type = 'button';
      botao.className = 'ftw-descricao__botao ftw-avaliacoes__mais';
      botao.setAttribute('aria-expanded', 'false');
      botao.innerHTML = '<span data-ftw-descricao-rotulo>Ver mais avaliações</span><span class="ftw-descricao__seta" aria-hidden="true">▼</span>';
      secao.appendChild(botao);
      botao.addEventListener('click', function () {
        secao.classList.remove('is-recolhida');
        botao.remove();
      });
      return true;
    };

    if (pronto()) return;
    var observa = new MutationObserver(function () {
      if (pronto()) observa.disconnect();
    });
    observa.observe(secao, { childList: true, subtree: true });
  }

  function inicia() {
    avaliacoes();
    alturaBarra();
    titulos();
    document.querySelectorAll('[data-ftw-descricao]').forEach(descricao);

    // A fonte do nome pode chegar depois do primeiro desenho: mede de novo quando ela carregar.
    if (document.fonts) {
      document.fonts.load('500 32px Oswald').then(titulos, function () {});
      document.fonts.addEventListener('loadingdone', titulos);
    }
    var h1 = document.querySelector('[data-ftw-titulo]');
    if (h1 && 'ResizeObserver' in window) {
      var largura = 0;
      new ResizeObserver(function (entradas) {
        var w = Math.round(entradas[0].contentRect.width);
        if (w === largura) return;
        largura = w;
        titulos();
      }).observe(h1.parentElement);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicia);
  } else {
    inicia();
  }
})();
